import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from './LanguageContext';
// Simple counter component
const Counter = ({
  end,
  suffix = '',
  duration = 2000
}) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (isInView) {
      let startTime = null;
      const animate = currentTime => {
        if (!startTime) startTime = currentTime;
        const progress = Math.min((currentTime - startTime) / duration, 1);
        // Ease out expo
        const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
        setCount(Math.floor(easeProgress * end));
        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };
      requestAnimationFrame(animate);
    }
  }, [isInView, end, duration]);
  return <span ref={ref} data-id="element-304">
      {count}
      {suffix}
    </span>;
};
export function StatsData() {
  const {
    t
  } = useLanguage();
  const stats = [{
    label: t('stats.worldCup'),
    value: 7,
    suffix: ''
  }, {
    label: t('stats.titles'),
    value: 1,
    suffix: ''
  }, {
    label: t('stats.goals'),
    value: 700,
    suffix: '+'
  }, {
    label: t('stats.ronaldo'),
    value: 36,
    suffix: ''
  }];
  return <section className="py-12 md:py-20 bg-colombia-dark-blue relative overflow-hidden" data-id="element-305">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-306"></div>

      <div className="container relative z-10 mx-auto px-6 md:px-12" data-id="element-307">
        <div className="text-center mb-12" data-id="element-308">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-colombia-yellow font-oswald uppercase tracking-widest text-sm font-bold mb-2" data-id="element-309">
            {t('stats.label')}
          </motion.h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 divide-x-0 md:divide-x divide-white/20" data-id="element-310">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center px-4" data-id="element-311">
              <div className="text-4xl md:text-6xl font-oswald font-bold text-white mb-2 drop-shadow-lg" data-id="element-312">
                <Counter end={stat.value} suffix={stat.suffix} data-id="element-313" />
              </div>
              <div className="text-colombia-yellow font-oswald uppercase tracking-wider text-xs md:text-sm" data-id="element-314">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}